<div *ngIf="loader">
    <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [width]="'100%'" [height]="'15px'"></app-skeleton-loader>
    <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [width]="'80%'" [height]="'10px'"></app-skeleton-loader>
    <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [width]="'50%'" [height]="'35px'"></app-skeleton-loader>
</div>

<app-overview-card *ngIf="!loader" 
        [card_title]="'reports.landDevelopmentRate'" 
        [total_current]="overViewSummary?.land_development_current"
        [untillDate]="overViewSummary?.untillDate"
        [uniType]="UnitTypeEnum.percentage"></app-overview-card>